import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as CurrentUserActions from './current-user.actions';
import { OrgStaffUserInterfaceWithId } from '@sk/sk-interfaces';



export const CURRENT_USER_FEATURE_KEY = 'currentUser';

export interface CurrentUserState extends EntityState<OrgStaffUserInterfaceWithId> {
  currentUser: OrgStaffUserInterfaceWithId | undefined; // which Organization record has been selected
  currentUserLoaded: boolean; // has the Clients list been loaded
  firestoreCurrentUserError?: string | null; // last none error (if any)
}

export interface CurrentUserPartialState {
  readonly [CURRENT_USER_FEATURE_KEY]: CurrentUserState;
}

export const currentUserAdapter: EntityAdapter<OrgStaffUserInterfaceWithId> = createEntityAdapter<OrgStaffUserInterfaceWithId>({
  selectId: selectCurrenUserId
});

export const initialState: CurrentUserState = currentUserAdapter.getInitialState({
  // set initial required properties
  currentUser: undefined,
  currentUserLoaded: false
});


export function selectCurrenUserId(a: OrgStaffUserInterfaceWithId): string {
  //In this case this would be optional since primary key is id
  return a.id;
}


const currentUserReducer = createReducer(
  initialState,




  /**
   * ACTION FROM FireStore
   */


  on(CurrentUserActions.getFireStoreCurrentUser, (state, { organizationUserId }) => {
    if (state.firestoreCurrentUserError) {
      delete state.firestoreCurrentUserError;
    }
    return ({
      ...state
    });
  }),

  on(CurrentUserActions.fromFireStoreAddCurrentUser, (state, {user}) => {
    if (state.firestoreCurrentUserError) {
      delete state.firestoreCurrentUserError;
    }

    return currentUserAdapter.setOne(user, {
      ...state,
      currentUser: user,
      currentUserLoaded : true
    });
  }),




  on(CurrentUserActions.fromFireStoreCurrentUserError, (state, {
    error
  }) => {
    return {
      ...state,
      currentUser: null,
      firestoreCurrentUserError: error.message
    };
  }),

);


export function reducer(state: CurrentUserState | undefined, action: Action) {
  return currentUserReducer(state, action);
}
